import {gsap} from "gsap";
import {Draggable} from "gsap/Draggable";
import {Observer} from "gsap/Observer";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import {ScrambleTextPlugin} from "gsap/ScrambleTextPlugin";

gsap.registerPlugin(Draggable, Observer, ScrollTrigger, SplitText, ScrambleTextPlugin);

export {gsap};
export {Draggable};
export {Observer};
export {ScrollTrigger};
export {SplitText};
export {ScrambleTextPlugin};